import { GameWithScore, StudentResultsStore } from "../../../react/students/StudentResultsStore"
import { HeroScore } from "./HeroScore"

export enum HeroKeys {
    HERO_TIMES_PLAYED = "HERO_TIMES_PLAYED",
    HERO_SCORE = "HERO_SCORE",
    HERO_SCORES_LIST = "HERO_SCORES_LIST",
}

export class HeroStore {

    static getTimesPlayed = (): number => {
        const stringTimesPlayed = localStorage.getItem(HeroKeys.HERO_TIMES_PLAYED)
        if (stringTimesPlayed) {
            return parseInt(stringTimesPlayed)
        } else {
            return 0
        }
    }

    static incrementTimesPlayed = () => {
        const newTimesPlayed = HeroStore.getTimesPlayed() + 1
        localStorage.setItem(HeroKeys.HERO_TIMES_PLAYED, newTimesPlayed.toString())
    }

    static getScore = (): number => {
        const stringScore = localStorage.getItem(HeroKeys.HERO_SCORE)
        if (stringScore) {
            return parseInt(stringScore)
        } else {
            return 0
        }
    }

    static setScore = (score: number, gameCount: number) => {
        localStorage.setItem(HeroKeys.HERO_SCORE, score.toString())
        const userScore = new HeroScore(score, gameCount)
        HeroStore.saveUserScore(userScore)
    }

    private static saveUserScore = (score: HeroScore) => {
        const scores = HeroStore.getScores()
        scores.push(score)
        scores.sort(HeroScore.compareScores)

        StudentResultsStore.instance.addScore(GameWithScore.SUPER_HERO, score.score)

        const scoresJson = JSON.stringify(scores)
        localStorage.setItem(HeroKeys.HERO_SCORES_LIST, scoresJson)
    }

    static getScores = (): Array<HeroScore> => {
        const scoresJson = localStorage.getItem(HeroKeys.HERO_SCORES_LIST)
        if (scoresJson) {
            return JSON.parse(scoresJson)
        } else {
            return []
        }
    }

    static clearRepo = () => {
        localStorage.removeItem(HeroKeys.HERO_SCORE)
        localStorage.removeItem(HeroKeys.HERO_SCORES_LIST)
        localStorage.removeItem(HeroKeys.HERO_TIMES_PLAYED)
    }
}
